import { TL } from '@/components/design-system'
import { graphql, useStaticQuery } from 'gatsby'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import React from 'react'

type Props = Readonly<{
  className: string
}>

export const InformationEntreprise = (_: Props) => {
  const { t } = useTranslation()
  const data = useStaticQuery(graphql`
    query {
      images: allImageSharp {
        edges {
          node {
            resize {
              originalName
              src
            }
          }
        }
      }
    }
  `)

  const images = data.images.edges.map(({ node }) => node.resize)
  const linkedIn = images.find(i => i.originalName === 'linkedin.png')
  const youtube = images.find(i => i.originalName === 'youtube.png')
  const email = images.find(i => i.originalName === 'email.png')
  const www = images.find(i => i.originalName === 'globe_international.png')

  return (
      <div className="grid grid-cols-2 gap-5 py-12 px-16 rounded-2xl bg-lightblue max-lg:grid-cols-1 max-lg:gap-10">
        <section>
          <TL.Title size="h2">{ t('nous-suivre') }</TL.Title>

          <ul className="flex flex-col gap-2 mt-8 max-lg:mt-4">
            { linkedIn &&
                <li className="flex gap-2 items-center">
                  <img src={ linkedIn.src } alt="linkedin logo" width={ 30 } height={ 30 }/>
                  <a href={ t('reseaux-sociaux.linkedin-miwe')! } target="_blank">/mickaelwegerich</a>
                </li>
            }
            { linkedIn &&
                <li className="flex gap-2 items-center">
                  <img src={ linkedIn.src } alt="linkedin logo" width={ 30 } height={ 30 }/>
                  <a href={ t('reseaux-sociaux.linkedin')! } target="_blank">/3lights-technology</a>
                </li>
            }
            { youtube &&
                <li className="flex gap-2 items-center">
                  <img src={ youtube.src } alt="youtube logo" width={ 30 } height={ 30 }/>
                  <a href={ t('reseaux-sociaux.youtube')! } target="_blank">/3lights-technology</a>
                </li>
            }
          </ul>
        </section>

        <section>
          <TL.Title size="h2">{ t('nous-contacter') }</TL.Title>

          <ul className="flex flex-col gap-2 mt-8 max-lg:mt-4">
            { email &&
                <li className="flex gap-2 items-center">
                  <img src={ email.src } alt="linkedin logo" width={ 30 } height={ 30 }/>
                  <a href="mailto:contact@3lights-technology.com?subject=Contact">contact@3lights-technology.com</a>
                </li>
            }
            { www &&
                <li className="flex gap-2 items-center">
                  <img src={ www.src } alt="linkedin logo" width={ 30 } height={ 30 }/>
                  <a href="https://3lights-technology.com">https://3lights-technology.com</a>
                </li>
            }
          </ul>
        </section>
      </div>
  )
}

InformationEntreprise.defaultProps = {
  className: '',
  images: []
}
